import { api } from "../../lib";

export interface Task {
  id: string;
  name: string;
  slug: string;
  description?: string;
  displayOrder: number;
  isActive: boolean;
  createdAt?: string;
  updatedAt?: string;
}

export interface CreateTaskInput {
  name: string;
  slug: string;
  description?: string;
  displayOrder?: number;
}

export interface UpdateTaskInput {
  name?: string;
  slug?: string;
  description?: string;
  displayOrder?: number;
  isActive?: boolean;
}

export const tasksService = {
  getAll: async (): Promise<{ tasks: Task[] }> => {
    return api.get<{ tasks: Task[] }>("/admin/tasks");
  },

  getActive: async (): Promise<{ tasks: Task[] }> => {
    return api.get<{ tasks: Task[] }>("/tasks");
  },

  getById: async (id: string): Promise<Task> => {
    return api.get<Task>(`/admin/tasks/${id}`);
  },

  create: async (input: CreateTaskInput): Promise<Task> => {
    return api.post<Task>("/admin/tasks", input);
  },

  update: async (id: string, input: UpdateTaskInput): Promise<Task> => {
    return api.put<Task>(`/admin/tasks/${id}`, input);
  },

  deactivate: async (id: string): Promise<{ message: string }> => {
    return api.delete<{ message: string }>(`/admin/tasks/${id}`);
  },
};
